<template>
  <div class="g-articlePage">
    <div id="" class="articleBox">
      <header> <img src="../assets/tongwei/home.png" alt="" class="u-home" @click="back" /></header>
      <img src="../assets/tongwei/loading.gif" class="loading" v-show="loading" />
      <h1 :class="'title ' + articleInfor.title_font_size" v-html="this.Breaks(articleInfor.title)"></h1>
      <div :class="'m-listTitle ' + articleInfor.summary_font_size" v-html="this.Breaks(articleInfor.sub_title)"></div>
      <main>
        <article v-html="articleInfor.content"></article>
        <div class="g-tag" v-if="articleInfor.tags.length > 0">
          <router-link v-for="(item, index) in articleInfor.tags" :key="index" tag="span" :to="'/search/' + item">{{ item
          }}</router-link>
        </div>
        <div @click.stop="support($event, articleInfor.id, articleInfor)" class="u-supportBox">
          <img src="../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          <span>{{ articleInfor.support_counts }}</span>
        </div>
      </main>

      <footer>
        <img src="../assets/tongwei/home.png" alt="" class="u-home" @click="back" />
      </footer>
    </div>
  </div>

</template>

<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      articleInfor: {},
      loading: true,
    };
  },
  methods: {
    back() {
      console.log(window.history);
      if (window.history.length > 1) {
        this.$router.push("/");
      } else {
        this.$router.push("/index");
      }
    },
    getArticleInfor() {
      let that = this;
      this.$axios({
        method: "get",
        url:
          "/api/articles/article_info.json?article_id=" +
          this.$route.params.id,
      }).then((res) => {
        this.loading = false;
        this.articleInfor = res.data.data;
        document.title = res.data.data.title
        //跳转链接
        if (this.articleInfor.redirect_to != "") {
          window.location.href = this.articleInfor.redirect_to
        }
        this.wechat(
          res.data.data.title,
          res.data.data.content
            .replace(/<\/?.+?>/g, "")
            .replace(/ /g, "")
            .substring(0, 50),
          window.location.href
        );
      });
    },
    wechat: function (title, desc, href) {
      let requestUrl =
        "/api/weichat/gen_wx_js_signature.json?s_url=" +
        location.href;
      this.$axios({
        method: "get",
        url: requestUrl,
      }).then((res) => {
        console.log(res);

        wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.nonceStr,
          signature: res.data.data.signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareQZone",
          ],
        });
        wx.ready(function () {
          let imageurl =
            "http://www.nbd.com.cn/corp/2019newspaper/a_img/tongweishare.png";
          wx.onMenuShareTimeline({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareAppMessage({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareQQ({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });

          wx.onMenuShareQZone({
            title: title,
            desc: desc,
            link: href,
            imgUrl: imageurl,
            success: function () { },
            cancel: function () { },
          });
        });

        wx.error(function (res) {
          console.log(res);
        });
      });
    },
  },
  mounted() {
    this.getArticleInfor();
    console.log(window.history.length);

  },
  created() {
    console.log(this.$route.params.id);
    console.log(window.location.href);
  },
};
</script>
<style>
@import "../css/article.css";
</style>
<style scoped lang="scss">
.g-articlePage {
  background: url(../assets/tongwei/bg.png) no-repeat;
  background-size: 100% 100%;
  

}

.articleBox {
  padding: 0.266667rem 0.333333rem;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-y: auto;
  height: 100%;
  max-width: 750px;
  margin: 0 auto;
  box-sizing: border-box;
  font-family: "PingFang SC", 微软雅黑, "Source Han Sans CN", SimSun, Arial, "Microsoft YaHei", "Hiragino Sans GB", 宋体, Tahoma，arial, sans-serif !important;
}

.title {
  margin-top: 0;
  padding-top: 1rem;
  margin-bottom: 0.2rem;
  font-size: 0.64rem;
}

.m-listTitle {
  font-size: 0.4rem;
  margin-bottom: 0.6rem;
  font-weight: bolder;
}

footer,
header {
  height: 1.066667rem;
  background: url("../assets/tongwei/articleBottom.png");
  background-size: 100% 100%;
  padding: 0;
  margin: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0.32rem;
  box-sizing: border-box;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
}

header {
  position: fixed;
  top: 0;

}

.u-home {
  width: 2.106667rem;
  height: 0.72rem;
}

main {
  padding-bottom: 1.6rem;
  border-top: 1px solid #CECECE;

  .u-supportBox {
    position: relative;
    margin-top: .2667rem;
  }
}

.g-tag {
  margin-top: .4rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  span {
    padding: .1067rem .2133rem;
    background: #E4EBF3;
    color: #04458E;
    font-size: .32rem;
    margin-right: .1333rem;
  }
}
</style>